import _ from 'lodash';
import OrgPaidStatus from '~/utils/OrgPaidStatus';

const PermissionsHelper = function() {
  const isUserPremiumOrTrial = teams => {
    return _.some(teams, team => {
      let planType = team && team.license && team.license.planType;
      return planType === 'TRIAL' || planType === 'PRO' || planType === 'ENTERPRISE';
    });
  };

  const canUserEdit = user => {
    // let user = AuthFactory.getUser();
    if (!_.isEmpty(user) && !_.isEmpty(user.profile)) {
      let roles = user.profile.roles || [];
      if (roles.indexOf('SC_RD_ADMIN') > -1 || roles.indexOf('SC_RESEARCHER') > -1) {
        return true;
      }
    }
    return false;
  };

  const isOrgPaidOrTrial = state => {
    const { myState, orgState } = state;
    return isLoggedInAndPaidOrTrialing(myState, orgState);
  };

  const isLoggedInAndPaidOrTrialing = (myState, orgState) => {
    const { isLoggedIn } = myState;
    const { org } = orgState;
    const isPaidOrTrialing = OrgPaidStatus.isOrgPaidOrTrial(org);
    return isLoggedIn && isPaidOrTrialing; //Use Helpers.isOnPrem() to disable paywall when ENVIRONMENT is ONPREM
  };

  const isTeamPremiumOrTrial = () => {
    // let store = ReduxStore.get().getState(),
    //     teamState = store.teamState,
    //     teams = teamState.teams || [],
    //     team = _.find(teams, (team) => { return team.id === teamId;}) || {},
    //     planType = team && team.license && team.license.planType;
    // if (_.isEmpty(team)) { return false; };
    // return planType && (planType === 'TRIAL' || planType === 'PRO' || planType === 'ENTERPRISE');
  };

  const isTeamPremium = () => {
    // let store = ReduxStore.get().getState(),
    //   teamState = store.teamState,
    //   teams = teamState.teams || [],
    //   team = _.find(teams, (team) => { return team.id === teamId;}) || {},
    //   planType = team && team.license && team.license.planType;
    // if (_.isEmpty(team)) { return false; };
    // return planType && (planType === 'PRO' || planType === 'ENTERPRISE');
  };

  const isLoggedIn = user => {
    return user != null;
    // return AuthFactory.isLoggedIn();
  };

  return {
    isUserPremiumOrTrial,
    canUserEdit,
    isLoggedIn,
    isLoggedInAndPaidOrTrialing,
    isTeamPremiumOrTrial,
    isTeamPremium,
    isOrgPaidOrTrial,
  };
};

export default new PermissionsHelper();
